import S from 's-js';
import { DomainSummary } from 'data/models/DomainSummary';
import { UserSummary } from 'data/models/UserSummary';
import { Entrypoints } from 'core/app/entrypoints';
import { IAjax } from 'lib/Ajax';
import { PCCache } from 'data/PCCache';
import { Login, LoginParams } from 'portcall/login/model';
import { PersonProfilePage, PersonProfilePageParams } from 'portcall/personprofilepage/model';
import { PersonProfilePageCache } from 'portcall/personprofilepage/cache';
import { PersonProfilePopupCache } from 'portcall/personprofilepopup/cache';

export type MePage = ReturnType<typeof MePage>;
export function MePage(
    user : () => UserSummary | null,
    loginModel : (params : LoginParams) => Login,
    personProfilePageModel : (params : PersonProfilePageParams) => PersonProfilePage
) {
    let showLogin = S.data(false),
        login = S(() => showLogin() ? loginModel({ useLandingPage: false, onHidePopup: () => showLogin(false) }) : null),
        personProfilePage = S(() => {
            let u = user();
            if (u) return personProfilePageModel(new PersonProfilePageParams(u.Id()));
            return null;
        });

    // TH: Hmmm... The idea here was to prompt users for login if their cookie expires.
    // But this is interacting badly w/ the new behavior of loading the site while the user summary request is still in flight...
    // if (!S.sample(user)) showLogin(true);

    return {
        Login: login,
        PersonProfilePage: personProfilePage
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/mepage/model.ts